export default "__VITE_ASSET__Ber61QYu__"